"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _underscore = require("underscore");

var _DynoEditor = require("lead-flows-ui/constants/DynoEditor");

var _PublishModal = _interopRequireDefault(require("lead-flows-ui/components/editor/navigation/PublishModal"));

var _RouteGenerators = require("lead-flows-ui/lib/RouteGenerators");

var _NextStepButton = _interopRequireDefault(require("lead-flows-ui/components/editor/navigation/buttons/NextStepButton"));

var _LastStepButton = _interopRequireDefault(require("lead-flows-ui/components/editor/navigation/buttons/LastStepButton"));

var _InvalidLastStepButton = _interopRequireDefault(require("lead-flows-ui/components/editor/navigation/buttons/InvalidLastStepButton"));

var _DynoUtils = require("lead-flows-ui/utils/DynoUtils");

var EDITOR_STEPS = Object.values(_DynoEditor.STEPS || {});

var NextButton =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(NextButton, _PureComponent);
  (0, _createClass2.default)(NextButton, null, [{
    key: "propTypes",
    get: function get() {
      return {
        dyno: _react.PropTypes.object.isRequired,
        currentStep: _react.PropTypes.oneOf(EDITOR_STEPS).isRequired,
        handleAdvanceStep: _react.PropTypes.func.isRequired,
        handlePublish: _react.PropTypes.func.isRequired,
        saving: _react.PropTypes.bool.isRequired,
        savingHasError: _react.PropTypes.bool.isRequired,
        scriptLoaderIsInstalled: _react.PropTypes.bool.isRequired,
        validation: _react.PropTypes.object,
        redirectUrl: _react.default.PropTypes.string,
        savingRecentError: _react.default.PropTypes.object
      };
    }
  }]);

  function NextButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, NextButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(NextButton).call(this, props));
    _this.state = {
      showModal: false,
      hasSaved: false
    };
    _this.showModal = _this.showModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleModalConfirm = _this.handleModalConfirm.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(NextButton, [{
    key: "langKey",
    value: function langKey(suffix) {
      return "leadFlowEditor.secondaryNavigation." + suffix;
    }
  }, {
    key: "showModal",
    value: function showModal() {
      this.setState({
        showModal: true
      });
    }
  }, {
    key: "handleModalConfirm",
    value: function handleModalConfirm() {
      var _this$props = this.props,
          dyno = _this$props.dyno,
          savingHasError = _this$props.savingHasError,
          scriptLoaderIsInstalled = _this$props.scriptLoaderIsInstalled,
          handlePublish = _this$props.handlePublish;
      var hasSaved = this.state.hasSaved;
      var primaryCTA = (0, _DynoUtils.getDynoPrimaryCTA)(dyno);

      if (hasSaved && savingHasError) {
        this.setState({
          showModal: false,
          hasSaved: false
        });
        return;
      }

      if (hasSaved && !scriptLoaderIsInstalled) {
        this.setState({
          showModal: false
        });
        window.location.href = "https://" + window.location.hostname + (0, _RouteGenerators.getEmbedCodeRoute)();
        return;
      }

      this.setState({
        hasSaved: true
      });
      handlePublish(primaryCTA);
    }
  }, {
    key: "getPrimaryCTAState",
    value: function getPrimaryCTAState() {
      var _this$props2 = this.props,
          currentStep = _this$props2.currentStep,
          validation = _this$props2.validation;
      var isInvalid = Object.keys(validation || {}).length > 0;
      var isLastStep = currentStep === (0, _underscore.last)(EDITOR_STEPS);
      var state;

      if (isInvalid && isLastStep) {
        state = 'INVALID_LAST_STEP';
      } else if (isLastStep) {
        state = 'LAST_STEP';
      } else {
        state = 'NEXT_STEP';
      }

      return state;
    }
  }, {
    key: "renderPrimaryCTA",
    value: function renderPrimaryCTA(state) {
      var _this$props3 = this.props,
          dyno = _this$props3.dyno,
          validation = _this$props3.validation,
          handleAdvanceStep = _this$props3.handleAdvanceStep,
          saving = _this$props3.saving;
      var lastStepLabel = (0, _DynoUtils.getDynoPrimaryCTA)(dyno);
      var disabled = saving;

      switch (state) {
        case 'NEXT_STEP':
          return _react.default.createElement(_NextStepButton.default, {
            onClick: handleAdvanceStep
          });

        case 'INVALID_LAST_STEP':
          return _react.default.createElement(_InvalidLastStepButton.default, {
            label: lastStepLabel,
            validation: validation
          });

        case 'LAST_STEP':
          return _react.default.createElement(_LastStepButton.default, {
            label: lastStepLabel,
            onClick: this.showModal,
            disabled: disabled
          });

        default:
          return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var dyno = this.props.dyno;
      var primaryCTAState = this.getPrimaryCTAState();
      var primaryCTA = (0, _DynoUtils.getDynoPrimaryCTA)(dyno);
      return _react.default.createElement("div", {
        className: "next-publish-btn-container"
      }, this.renderPrimaryCTA(primaryCTAState), _react.default.createElement(_PublishModal.default, {
        showModal: this.state.showModal,
        primaryCTA: primaryCTA,
        hasSaved: this.state.hasSaved,
        saving: this.props.saving,
        savingHasError: this.props.savingHasError,
        validation: this.props.validation,
        savingRecentError: this.props.savingRecentError,
        scriptLoaderIsInstalled: this.props.scriptLoaderIsInstalled,
        handleConfirm: this.handleModalConfirm,
        handleReject: function handleReject() {
          return _this2.setState({
            showModal: false,
            hasSaved: false
          });
        }
      }));
    }
  }]);
  return NextButton;
}(_react.PureComponent);

exports.default = NextButton;
module.exports = exports.default;